import { IconButton } from '@bridebook/aura';
import { ChevronLeft } from '@bridebook/aura/src/icons';
import {
  PreventableEvent,
  useNavigateBack,
} from '@bridebook/web/lib/utils/hooks/use-navigate-back';
import { FunctionComponent, memo } from 'react';

interface IAppBarBackProps {
  onClick?: (e?: PreventableEvent) => void;
}

const AppBarBackButton: FunctionComponent<IAppBarBackProps> = ({ onClick }: IAppBarBackProps) => {
  const { navigateBackWithPreventDefault } = useNavigateBack();

  return (
    <IconButton icon={ChevronLeft} onClick={onClick || navigateBackWithPreventDefault} size="sm" />
  );
};

export default memo(AppBarBackButton);
